import React, { Component } from 'react';
import Modal from '../../helpers/Modal';
import { HTML_CLASSES } from '../../../constants/admin/settings';

class RTEWithComments extends Component {
    state = {
        modalComment: '',
        hoverSet: false,
        currentComment: '',
        bottom: 0,
        top: 0,
        height: 0,
        left: 0,
        right: 0,
        width: 0
    };
    _iterateCommentNodes = functionToUse => {
        const comments = document.getElementsByClassName(`${HTML_CLASSES.RTE_JS_COMMENTS}`);
        for (var i = 0, len = comments.length; i < len; i++) {
            functionToUse(comments[i]);
        }
    };
    _onHover = ev => {
        let id = ev.target.id;
        if (id) {
            const target = document.getElementById(id).getBoundingClientRect();
            this.setState({
                height: target.bottom - target.top,
                top: target.top,
                bottom: target.bottom,
                left: target.left,
                right: target.right,
                width: target.right - target.left,
                currentComment: this.props.comments[id]
            });
        }
    };
    _onLeave = () => {
        this.setState({ currentComment: '' });
    };
    _onClick = ev => {
        let id = ev.target.id;
        if (!this.props.editing && id) {
            this.setState({
                modalComment: this.props.comments[id]
            });
        }
    };
    _closeModal = () => {
        this.setState({ modalComment: '' });
    };
    _removeListeners = () => {
        this._iterateCommentNodes(n => {
            n.removeEventListener('mouseover', this._onHover);
        });
        this._iterateCommentNodes(n => {
            n.removeEventListener('mouseleave', this._onLeave);
        });
        this._iterateCommentNodes(n => {
            n.addEventListener('click', this._onClick);
        });
    };
    _addListeners = () => {
        this._iterateCommentNodes(n => {
            n.addEventListener('mouseover', this._onHover);
        });
        this._iterateCommentNodes(n => {
            n.addEventListener('mouseleave', this._onLeave);
        });
        this._iterateCommentNodes(n => {
            n.addEventListener('click', this._onClick);
        });
    };
    componentDidUpdate(previousProps) {
        if (
            (this.props.data && this.state.hoverSet !== this.props.version) ||
            (previousProps.editing && !this.props.editing)
        ) {
            setTimeout(() => this.setListeners(), 500);
        }
    }
    componentWillUnmount() {
        this._removeListeners();
    }
    setListeners = () => {
        if (!this.props.disabled) {
            this._removeListeners();
            this._addListeners();
            this.setState({ hoverSet: this.props.version });
        }
    };
    render() {
        return (
            <React.Fragment>
                <div
                    style={{
                        width: this.state.width - 20,
                        bottom: window.innerHeight - this.state.bottom + this.state.height + 10
                    }}
                    dangerouslySetInnerHTML={{
                        __html: `<span class='u-bold ckp-ts-h4 u-margin-bottom-1'>${this.props.user}</span><br />${(
                            this.state.currentComment || ''
                        ).replace(/(?:\r\n|\r|\n)/g, '<br />')}`
                    }}
                    className={`ckp-contracts-comments ${this.state.currentComment ? '' : 'is-hidden'}`}
                />
                {React.cloneElement(this.props.children, { setCommentListeners: this.setListeners })}
                <Modal onClose={this._closeModal} open={!!this.state.modalComment}>
                    <React.Fragment>
                        <h3 className="ckp-ts-h3 u-bold u-margin-bottom-2">Comment by {this.props.user}</h3>
                        <div className="u-italic">{this.state.modalComment}</div>
                    </React.Fragment>
                </Modal>
            </React.Fragment>
        );
    }
}

export default RTEWithComments;



// WEBPACK FOOTER //
// ./src/components/admin/hocs/RTEWithComments.js